import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatRipple } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { selectCustomerProfileExists, selectRole } from '@asset-solutions/customer-portal/auth/data-access';
import { CUSTOMER_PORTAL_CONFIG, featureIsEnabled } from '@asset-solutions/customer-portal/config';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Store } from '@ngrx/store';

import { NavigationItems } from './navigation-item';

@Component({
  selector: 'cp-navigation',
  imports: [MatRipple, RouterLink, RouterLinkActive, MatIcon, FontAwesomeModule],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationComponent {
  private readonly featureFlags = inject(CUSTOMER_PORTAL_CONFIG).featureFlags;
  private readonly store = inject(Store);

  protected navigationItems = NavigationItems.filter((item) => {
    return !item.featureFlag || featureIsEnabled(item.featureFlag, this.featureFlags);
  });
  protected hasCustomerProfile = this.store.selectSignal(selectCustomerProfileExists);
  protected role = this.store.selectSignal(selectRole);
}
